/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
// import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleExclamation,
  faCirclePlus,
  faCopy,
  faEye,
  faPenToSquare,
  faReply,
  faSearch,
  faTrashCan,
} from '@fortawesome/free-solid-svg-icons'
import {
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
  Form,
  Modal,
  InputGroup,
  Container,
} from 'react-bootstrap'
import { Context, ToastContext } from './ContextProvider'
import apiServices from '../services/apiServices'

function ShowModal({ setting }) {
  const { show, tag, handleClose } = setting
  // useEffect(() => {
  //   const script = document.createElement('script')
  //   script.type = 'text/javascript'
  //   script.appendChild(document.createTextNode(``))

  //   const parent = document.head // or document.body;
  //   parent.appendChild(script)
  // })
  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      onHide={() => handleClose()}
      className="py-2 px-4"
    >
      <Modal.Header closeButton />
      <Modal.Body className="p-4">
        <iframe
          width="100%"
          height="500"
          title="preview"
          src={`https://cowrie.punwave.com/preview?tag=${tag.tag_id}`}
        />
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="ms-auto me-2"
          style={{ boxShadow: 'none' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取 消
        </Button>
        <Button
          className="me-auto"
          style={{ boxShadow: 'none' }}
          variant="narwhal"
          onClick={() => handleClose(true)}
        >
          確 認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function DeleteModal({ setting }) {
  const { show, name, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      onHide={() => handleClose()}
      className="py-2 px-4"
    >
      <Modal.Header closeButton />
      <Modal.Body className="p-4">
        <div className="d-flex">
          <FontAwesomeIcon
            className="px-0 m-auto text-chelonia text-center"
            style={{
              height: '100px',
            }}
            icon={faCircleExclamation}
          />
        </div>
        <h5 className="text-center lh-lg text-chelonia">
          <br />
          警告！刪除後無法復原！
          <br />
          仍要刪除
          <span className="text-danger">{`「${name}」標籤`}</span>
          嗎？
        </h5>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="ms-auto me-2"
          style={{ boxShadow: 'none' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取 消
        </Button>
        <Button
          className="me-auto"
          style={{ boxShadow: 'none' }}
          variant="narwhal"
          onClick={() => handleClose(true)}
        >
          確 認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function ProjectModal({ setting }) {
  const {
    show,
    form,
    defaultValue = {},
    setDuration,
    handleClose,
    data,
    onDataChange,
  } = setting
  const [showDate, setshowDate] = useState(false)

  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      onHide={() => handleClose()}
      className="py-2 px-4"
    >
      <Modal.Header closeButton>
        {defaultValue.setting ? `編輯標籤` : `新建標籤`}
      </Modal.Header>
      <Modal.Body className="p-4">
        {form.map((f, i) => {
          switch (f.type) {
            case 'date':
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      name={f.name}
                      type="text"
                      value={data[f.name] || f.placeholder}
                      placeholder={f.placeholder}
                      onFocus={() => setshowDate(!showDate)}
                      readOnly
                    />
                    <Button
                      variant="chelonia2"
                      onClick={() => setshowDate(!showDate)}
                    >
                      確認
                    </Button>
                  </InputGroup>
                </React.Fragment>
              )
            case 'select':
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>

                  <Form.Select
                    name={f.name}
                    type={f.type}
                    value={data[f.name] || ''}
                    onChange={onDataChange}
                    placeholder={f.placeholder}
                    onFocus={() => setshowDate(false)}
                  >
                    <option value="">未選擇</option>
                    {f.content.map((c) => (
                      <option value={c}>{c}</option>
                    ))}
                  </Form.Select>
                </React.Fragment>
              )
            case 'file':
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>

                  <Form.Control
                    name={f.name}
                    type={f.type}
                    onChange={async (e) => {
                      // const formData = new FormData()
                      // formData.append('file', e.target.files[0])
                      onDataChange({
                        target: {
                          name: f.name,
                          value: e.target.files[0],
                        },
                      })
                      console.log('file append')
                      const temp = URL.createObjectURL(e.target.files[0])
                      const audio = document.createElement('audio')
                      audio.muted = true
                      console.log('audio created')
                      const source = document.createElement('source')
                      source.src = temp // --> blob URL
                      audio.preload = 'metadata'
                      audio.appendChild(source)
                      console.log('reading metadata')
                      audio.onloadedmetadata = () => {
                        console.log(audio.duration)
                        setDuration(audio.duration)
                      }
                      // const uploaded = await apiServices.data({
                      //   path: `material/file`,
                      //   method: 'post',
                      //   data: formData,
                      //   contentType: 'multipart/form-data',
                      // })
                      // console.log(uploaded)
                    }}
                    placeholder={f.placeholder}
                    onFocus={() => setshowDate(false)}
                  />
                </React.Fragment>
              )
            case 'textarea':
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>

                  <Form.Control
                    name={f.name}
                    type="text"
                    as="textarea"
                    rows="10"
                    value={data[f.name] || ''}
                    onChange={onDataChange}
                    placeholder={f.placeholder}
                    onFocus={() => setshowDate(false)}
                  />
                </React.Fragment>
              )
            default:
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>

                  <Form.Control
                    name={f.name}
                    type={f.type}
                    value={data[f.name] || ''}
                    onChange={onDataChange}
                    placeholder={f.placeholder}
                    onFocus={() => setshowDate(false)}
                  />
                </React.Fragment>
              )
          }
        })}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="ms-auto"
          style={{ boxShadow: 'none' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取 消
        </Button>
        <Button
          className="me-auto"
          style={{ boxShadow: 'none' }}
          variant="narwhal"
          onClick={() => handleClose(true)}
        >
          確 認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function Tags() {
  // const navigate = useNavigate()

  const [selectedId, setselectedId] = useState('')
  //   const [warn, setWarn] = useState({
  //     show: false,
  //     text: '',
  //     handleClose: () => {},
  //   })

  //   const { auth } = useContext(AuthContext)
  const {
    tags,
    containerId,
    setContainerId,
    handleAddTag,
    handleEditTag,
    handleDeleteTag,
  } = useContext(Context)
  const { setToast } = useContext(ToastContext)

  const form = [
    {
      name: 'name',
      label: '名稱',
      placeholder: '輸入名稱',
      type: 'text',
    },
    {
      name: 'limit',
      label: 'Adtag',
      placeholder: '輸入播放次數上限',
      type: 'tel',
    },
    {
      name: 'percent',
      label: 'Adtag',
      placeholder: '輸入播放比例',
      type: 'tel',
    },
    {
      name: 'adtag',
      label: 'Adtag',
      placeholder: '輸入代碼',
      type: 'textarea',
    },
  ]

  const [show, setshow] = useState(false)
  const [data, setdata] = useState({})
  const onDataChange = (e) =>
    setdata({ ...data, [e.target.name]: e.target.value })
  useEffect(() => {
    if (show) {
      setdata(
        form.reduce(
          (prev, cur) => ({
            ...prev,
            [cur.name]: '',
          }),
          {}
        )
      )
    }
  }, [show])

  const handleClose = (value) => {
    setshow(false)
    if (!value) return
    const { name } = data
    handleAddTag(name, data)
  }

  const [deleteShow, setdeleteShow] = useState(false)
  const handleDeleteClose = (value) => {
    setdeleteShow(false)
    if (value) {
      handleDeleteTag(selectedId)
    }
  }

  const [tempSearch, setTempSearch] = useState('')
  const [search, setSearch] = useState('')
  const [focus, setFocus] = useState(false)

  const [showEdit, setshowEdit] = useState(false)
  const [editData, seteditData] = useState({})
  const onEditDataChange = (e) =>
    seteditData({ ...editData, [e.target.name]: e.target.value })
  const handleCloseEdit = (value) => {
    setshowEdit(false)
    console.log(value)
    if (value) {
      handleEditTag(selectedId, editData.name, {
        ...editData,
      })
    }
    // if (!value) return
  }

  useEffect(() => {
    const target = tags.find(({ tag_id }) => tag_id === selectedId) || {}
    seteditData(
      form.reduce(
        (prev, cur) => ({
          ...prev,
          [cur.name]: target.setting
            ? target.setting[cur.name] || target[cur.name] || ''
            : '',
        }),
        {}
      )
    )
  }, [selectedId])

  const [records, setrecords] = useState([])
  useEffect(() => {
    const getRecords = async () => {
      const res = await apiServices.data({
        path: 'record',
        method: 'get',
      })
      setrecords(res)
    }
    getRecords()
  }, [])

  const refinedRecords = useMemo(
    () =>
      records
        .filter((record) => {
          const target = tags.find((tag) => tag.tag_id === record.tag_id)
          return target
        })
        .map((record) => {
          const target = tags.find((tag) => tag.tag_id === record.tag_id)
          return {
            visitorId: record.setting.visitorId,
            ip: record.setting.ip || 'not recorded',
            tagName: target.name,
            type: record.type,
            languages: record.setting.components.languages.value, // array
            platform: record.setting.components.platform.value,
            plugins: record.setting.components.plugins.value,
            screenResolution: record.setting.components.screenResolution.value,
            timezone: record.setting.components.timezone.value,
            vendor: record.setting.components.vendor.value,
            vendorFlavors: record.setting.components.vendorFlavors.value,
            videoCard: record.setting.components.videoCard.value,
          }
        }),
    [records, tags]
  )
  console.log(refinedRecords)

  const cluster = useMemo(
    () =>
      refinedRecords.reduce(
        (prev, cur) => ({
          ...prev,
          ip: {
            ...prev.ip,
            [cur.ip]: [...(prev.ip[cur.ip] || []), cur],
          },
          id: {
            ...prev.id,
            [cur.visitorId]: [...(prev.ip[cur.visitorId] || []), cur],
          },
          ipid: {
            ...prev.ipid,
            [`${cur.ip}_${cur.visitorId}`]: [
              ...(prev.ip[`${cur.ip}_${cur.visitorId}`] || []),
              cur,
            ],
          },
        }),
        {
          ip: {},
          id: {},
          ipid: {},
        }
      ),
    [refinedRecords]
  )

  console.log(cluster)

  const [showTag, setshowTag] = useState(false)
  return (
    <Container className="d-flex flex-column pt-3">
      <Row className="px-5">
        <Col xs={2} className="d-flex">
          <h5 className="my-auto text-chelonia-light fw-bold">標籤管理</h5>
        </Col>
        <Col xs={2} />
        <Col xs={3} className="d-flex justifu-content-end" />
        <Col xs={5} className="d-flex pe-0">
          <InputGroup>
            <Form.Control
              placeholder="輸入關鍵字以搜尋標籤..."
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
              value={tempSearch}
              onChange={(event) => setTempSearch(event.target.value)}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              onKeyDown={(event) => {
                if (
                  event.key === 'Enter' &&
                  !event.nativeEvent.isComposing &&
                  focus
                )
                  setSearch(tempSearch)
              }}
            />
            <Button
              variant="outline-dark"
              id="button-addon2"
              title="搜 尋"
              onClick={() => setSearch(tempSearch)}
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
          <Button
            className="ms-4 w-50"
            variant="narwhal"
            onClick={() => {
              // setselectedId('')
              setshow(true)
            }}
          >
            新增標籤&ensp;
            <FontAwesomeIcon icon={faCirclePlus} />
          </Button>
          <Button
            className="ms-4 w-50"
            variant="narwhal"
            onClick={() => {
              setContainerId('')
            }}
          >
            回容器列表&ensp;
            <FontAwesomeIcon icon={faReply} />
          </Button>
        </Col>
      </Row>
      <Row
        className="flex-grow-1 pt-3 pb-5 px-5"
        style={{ overflowY: 'auto', overflowX: 'hidden' }}
      >
        <ListGroup className="pe-0 h-100">
          <ListGroupItem className="d-flex row">
            <Col>
              <Form.Control
                className="border-0"
                readOnly
                as="textarea"
                rows={3}
                value={`<script>
  const loadAdScript = () => {
    fetch('https://cowrie.punwave.com/api/adtag/${containerId}').then((res) => {
      return res.json()
    }).then((attr) => {
      console.log(attr.tag)
      document.write(attr.tag)
      FingerprintJS.load().then(fp => {
        fp.get().then(result => {
          console.log(result)
          fetch('https://cowrie.punwave.com/api/adtag/fp/' + attr.tag_id, {
                  body: JSON.stringify(result),
                  cache: "no-cache",
                  credentials: "same-origin",
                  headers: {
                  "user-agent": "Mozilla/4.0 MDN Example",
                  "content-type": "application/json",
                  },
                  method: "POST",
                  mode: "cors",
                  redirect: "follow",
                  referrer: "no-referrer",
              })
          function clickBody(){
            fetch('https://cowrie.punwave.com/api/adtag/click/' + attr.tag_id, {
                  body: JSON.stringify(result),
                  cache: "no-cache",
                  credentials: "same-origin",
                  headers: {
                  "user-agent": "Mozilla/4.0 MDN Example",
                  "content-type": "application/json",
                  },
                  method: "POST",
                  mode: "cors",
                  redirect: "follow",
                  referrer: "no-referrer",
              })
          }
          document.body.addEventListener("click", clickBody)
    })
})
                                })}
</script>
<script async src="//cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@3/dist/fp.min.js" onload="loadAdScript()"></script>`}
              />
            </Col>
            <Col className="d-flex" xs={1}>
              <Button
                className="m-auto"
                style={{ boxShadow: 'none' }}
                variant="red"
                onClick={() => {
                  navigator.clipboard.writeText(`<script>
  const loadAdScript = () => {
    fetch('https://cowrie.punwave.com/api/adtag/${containerId}').then((res) => {
      return res.json()
    }).then((attr) => {
      console.log(attr.tag)
      document.write(attr.tag)
      FingerprintJS.load().then(fp => {
        fp.get().then(result => {
          console.log(result)
          fetch('https://cowrie.punwave.com/api/adtag/fp/' + attr.tag_id, {
                  body: JSON.stringify(result),
                  cache: "no-cache",
                  credentials: "same-origin",
                  headers: {
                  "user-agent": "Mozilla/4.0 MDN Example",
                  "content-type": "application/json",
                  },
                  method: "POST",
                  mode: "cors",
                  redirect: "follow",
                  referrer: "no-referrer",
              })
          function clickBody(){
            fetch('https://cowrie.punwave.com/api/adtag/click/' + attr.tag_id, {
                  body: JSON.stringify(result),
                  cache: "no-cache",
                  credentials: "same-origin",
                  headers: {
                  "user-agent": "Mozilla/4.0 MDN Example",
                  "content-type": "application/json",
                  },
                  method: "POST",
                  mode: "cors",
                  redirect: "follow",
                  referrer: "no-referrer",
              })
          }
          document.body.addEventListener("click", clickBody)
    })
})
                                })}
</script>
<script async src="//cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@3/dist/fp.min.js" onload="loadAdScript()"></script>`)
                  setToast({ show: true, text: '已 複 製 代 碼' })
                }}
                title="複製"
              >
                <FontAwesomeIcon icon={faCopy} />
              </Button>
            </Col>
          </ListGroupItem>
        </ListGroup>
      </Row>
      <Row
        className="pt-3 pb-5 px-5"
        style={{ overflowY: 'auto', overflowX: 'hidden', height: '25vh' }}
      >
        {tags && tags.length ? (
          <ListGroup className="pe-0 h-100">
            {tags
              .filter(
                ({ name, setting }) =>
                  !search ||
                  (Object.keys(setting).some(
                    (key) =>
                      setting[key] &&
                      `${setting[key]}`
                        .toLowerCase()
                        .includes(search.toLowerCase())
                  ) &&
                    (!search || name.includes(search)))
              )
              .map(({ name, tag_id, setting }) => (
                <ListGroupItem className="d-flex row" key={tag_id}>
                  <Col
                    xs={3}
                    className="my-auto text-start oneLineEllipsis fs-7"
                    title={name}
                  >
                    {name}
                  </Col>
                  <Col xs={3} className="my-auto text-start ps-2">
                    <div className="fs-7 fw-regular text-chelonia">
                      建立者｜
                    </div>
                    <div className="fs-7 fw-regular text-chelonia">
                      建立時間｜
                    </div>
                  </Col>
                  <Col
                    xs={3}
                    className="my-auto text-start oneLineEllipsis fs-7"
                    title={name}
                  >
                    <div className="fs-7 fw-regular text-chelonia">
                      點擊次數｜{setting.clicks || '未追蹤'}
                    </div>
                    <div className="fs-7 fw-regular text-chelonia">
                      播放次數｜{setting.times || 0} /{' '}
                      {setting.limit || '未設定'}
                    </div>
                    <div className="fs-7 fw-regular text-chelonia">
                      播放比例｜
                      {setting.percent ? `${setting.percent}%` : '未設定'}
                    </div>
                  </Col>
                  <Col xs={3} className="d-flex my-auto">
                    <Button
                      className="ms-auto"
                      style={{ boxShadow: 'none' }}
                      variant="edit"
                      onClick={() => {
                        setselectedId(tag_id)
                        setshowTag(true)
                      }}
                      title="重 新 命 名"
                      size
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </Button>
                    <Button
                      className="ms-auto"
                      style={{ boxShadow: 'none' }}
                      variant="edit"
                      onClick={() => {
                        setselectedId(tag_id)
                        setshowEdit(true)
                      }}
                      title="重 新 命 名"
                      size
                    >
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </Button>
                    <Button
                      style={{ boxShadow: 'none' }}
                      variant="red"
                      onClick={() => {
                        setselectedId(tag_id)
                        setdeleteShow(true)
                      }}
                      title="刪 除"
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </Button>
                  </Col>
                </ListGroupItem>
              ))}
          </ListGroup>
        ) : (
          <div className="d-flex ps-3 border">
            <h5 className="m-auto text-chelonia-light">目前尚無資料</h5>
          </div>
        )}
      </Row>
      <Row className="px-5">
        <Col xs={2} className="d-flex">
          <h5 className="my-auto text-chelonia-light fw-bold">紀錄</h5>
        </Col>
      </Row>
      <Row
        className="flex-grow-1 pt-3 pb-5 px-5 h-100"
        style={{ overflowY: 'auto', overflowX: 'hidden', height: '50vh' }}
      >
        {refinedRecords && refinedRecords.length ? (
          <ListGroup className="pe-0">
            {refinedRecords.map((record, i) => (
              <ListGroupItem className="d-flex row" key={i}>
                <Col
                  xs={3}
                  className="my-auto text-start oneLineEllipsis fs-7"
                  title={record.visitorId}
                >
                  <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                    所屬廣告｜{record.tagName}
                  </div>
                  <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                    事件｜{record.type}
                  </div>
                  <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                    ID｜{record.visitorId}
                  </div>
                  <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                    IP｜{record.ip}
                  </div>
                </Col>
                <Col xs={2} className="my-auto text-start oneLineEllipsis fs-7">
                  <div className="fs-7 fw-regular text-chelonia">
                    時區｜{record.timezone}
                  </div>
                  {record.languages.map((language) => (
                    <div
                      className="fs-7 fw-regular text-chelonia"
                      key={language[0]}
                    >
                      語言｜{language[0]}
                    </div>
                  ))}
                </Col>
                <Col xs={4} className="my-auto text-start oneLineEllipsis fs-7">
                  <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                    裝置廠商｜{record.platform}
                  </div>
                  {record.videoCard && (
                    <>
                      <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                        顯示卡｜{record.videoCard.renderer}
                      </div>
                      <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                        顯示卡廠商｜{record.videoCard.vendor}
                      </div>
                    </>
                  )}
                </Col>
                <Col xs={3} className="my-auto text-start oneLineEllipsis fs-7">
                  {record.vendorFlavors.map((vf) => (
                    <div
                      className="fs-7 fw-regular text-chelonia App-oneLineEllipsis"
                      key={vf}
                    >
                      平台｜{vf}
                    </div>
                  ))}
                  {record.plugins.map((plugin) => (
                    <div
                      className="fs-7 fw-regular text-chelonia App-oneLineEllipsis"
                      key={plugin.name}
                    >
                      plugin｜{plugin.name}
                    </div>
                  ))}
                  <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                    瀏覽器廠商｜{record.vendor}
                  </div>
                </Col>
              </ListGroupItem>
            ))}
          </ListGroup>
        ) : (
          <div className="d-flex ps-3 border">
            <h5 className="m-auto text-chelonia-light">目前尚無資料</h5>
          </div>
        )}
      </Row>
      <Row className="px-5">
        <Col xs={2} className="d-flex">
          <h5 className="my-auto text-chelonia-light fw-bold">分群</h5>
        </Col>
      </Row>
      {Object.keys(cluster).map((key) => (
        <Row
          key={key}
          className="pt-3 pb-5 px-5"
          style={{ overflowY: 'auto', overflowX: 'hidden', height: '50vh' }}
        >
          {Object.keys(cluster[key]).map((identifier) => (
            <>
              <Row>
                {identifier}: 共{cluster[key][identifier].length}筆
              </Row>
              <ListGroup className="pe-0 h-100" key={identifier}>
                {cluster[key][identifier].map((record, i) => (
                  <ListGroupItem className="d-flex row" key={i}>
                    <Col
                      xs={3}
                      className="my-auto text-start oneLineEllipsis fs-7"
                      title={record.visitorId}
                    >
                      <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                        所屬廣告｜{record.tagName}
                      </div>
                      <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                        事件｜{record.type}
                      </div>
                      <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                        {key}｜{identifier}
                      </div>
                    </Col>
                    <Col
                      xs={2}
                      className="my-auto text-start oneLineEllipsis fs-7"
                    >
                      <div className="fs-7 fw-regular text-chelonia">
                        時區｜{record.timezone}
                      </div>
                      {record.languages.map((language) => (
                        <div
                          className="fs-7 fw-regular text-chelonia"
                          key={language[0]}
                        >
                          語言｜{language[0]}
                        </div>
                      ))}
                    </Col>
                    <Col
                      xs={4}
                      className="my-auto text-start oneLineEllipsis fs-7"
                    >
                      <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                        裝置廠商｜{record.platform}
                      </div>
                      {record.videoCard && (
                        <>
                          <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                            顯示卡｜{record.videoCard.renderer}
                          </div>
                          <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                            顯示卡廠商｜{record.videoCard.vendor}
                          </div>
                        </>
                      )}
                    </Col>
                    <Col
                      xs={3}
                      className="my-auto text-start oneLineEllipsis fs-7"
                    >
                      {record.vendorFlavors.map((vf) => (
                        <div
                          className="fs-7 fw-regular text-chelonia App-oneLineEllipsis"
                          key={vf}
                        >
                          平台｜{vf}
                        </div>
                      ))}
                      {record.plugins.map((plugin) => (
                        <div
                          className="fs-7 fw-regular text-chelonia App-oneLineEllipsis"
                          key={plugin.name}
                        >
                          plugin｜{plugin.name}
                        </div>
                      ))}
                      <div className="fs-7 fw-regular text-chelonia App-oneLineEllipsis">
                        瀏覽器廠商｜{record.vendor}
                      </div>
                    </Col>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </>
          ))}
        </Row>
      ))}
      {show && (
        <ProjectModal
          setting={{
            show,
            form,
            // duration,
            //   setDuration,
            // defaultValue: selectedId
            //   ? list.find((l) => l.material_id === selectedId)
            //   : {},
            data,
            onDataChange,
            defaultValue: {},
            handleClose,
          }}
        />
      )}
      <DeleteModal
        setting={{
          show: deleteShow,
          name: tags.find(({ tag_id }) => tag_id === selectedId)?.name,
          handleClose: handleDeleteClose,
        }}
      />
      {showTag && (
        <ShowModal
          setting={{
            show: showTag,
            tag: tags.find(({ tag_id }) => tag_id === selectedId),
            handleClose: () => setshowTag(false),
          }}
        />
      )}
      {selectedId && showEdit && (
        <ProjectModal
          setting={{
            show: showEdit,
            form,
            // duration,
            //   setDuration,
            // defaultValue: selectedId
            //   ? list.find((l) => l.material_id === selectedId)
            //   : {},
            data: editData,
            onDataChange: onEditDataChange,
            defaultValue: {},
            handleClose: handleCloseEdit,
          }}
        />
      )}
    </Container>
  )
}

ShowModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

DeleteModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

ProjectModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Tags
